import React, { useState } from "react"
import Menu from "@mui/material/Menu"

//images
import menuIcon from "@/assets/img/icons/table-menu.png"
import deleteIcon from "@/assets/img/icons/delete.svg"
import downloadIcon from "@/assets/img/icons/download.svg"
import { trans } from "@/_providers/Translation"

function DataExportOptions(props) {
  const [table, setTable] = useState({
    options: null,
  })

  const handleTableMenu = (e) => {
    setTable((table) => {
      return {
        ...table,
        options: e.currentTarget,
      }
    })
  }

  const handleCloseMenu = () => {
    setTable((table) => {
      return {
        ...table,
        options: null,
      }
    })
  }

  const handleDownload = (id) => {
    handleCloseMenu()

    props.handleDownload(id)
  }

  const handleDelete = (id) => {
    handleCloseMenu()

    props.handleDelete(id)
  }

  return (
    <>
      <img
        src={menuIcon}
        alt="menu"
        className="menu"
        onClick={handleTableMenu}
      />

      <Menu
        id={"menu-" + props.id}
        anchorEl={table.options}
        keepMounted
        open={Boolean(table.options)}
        onClose={handleCloseMenu}
      >
        <div 
        className="menu-option" 
        onClick={() => handleDownload(props.id)}
        >
          <img src={downloadIcon} alt="download" />
          {trans("options.downloadRecord")}
        </div>
        <div
          className="menu-option"
          onClick={() => handleDelete(props.id)}
          style={{
            color: "#EC5252",
          }}
        >
          <img src={deleteIcon} alt="delete" />
          {trans("options.delete")}
        </div>
      </Menu>
    </>
  )
}

export default DataExportOptions
